var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getFullTable from './getFullTable';
import getRecords from './getRecords';
import fetchRecordsByIds from './fetchRecordsByIds';
import arrayIsEmpty from '../arrayOperations/arrayIsEmpty';
import debuggerWhenDebugging from '../developer/debuggerWhenDebugging';
import firstNotEmptyArray from '../arrayOperations/firstNotEmptyArray';
/** Returns records identified by IDs. Queries local master data, then local data, then remote data */
export default function getRecordsByIds(entity, ids) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!ids || arrayIsEmpty(ids))
            return [];
        const filter = (arr) => arr.filter((r) => ids.includes(r.id));
        const result = firstNotEmptyArray(filter(getFullTable(entity)), filter(getRecords(entity)), yield fetchRecordsByIds(entity, ids));
        if (arrayIsEmpty(result))
            debuggerWhenDebugging();
        return result;
    });
}
